import EventTracking from 'lib/EventTracking';
import GroupActions from 'groups/actions/GroupActions';
import GroupDataOps from 'groups/lib/GroupDataOps';
import ToastActions from 'actions/ToastActions';
import JoinFlowGroupStorage from 'join/data/JoinFlowGroupStorage';

type RouterLike = {
  push: (path: string) => void;
};

/**
 * Post-Google join used to run in JoinGroupFormPanel.onSuccess. The GIS
 * redirect returns to /log_in, so SignInPage calls this with the stored
 * class code after AUTH_SUCCESS.
 */
export function completeGoogleJoin(groupCode: string, router: RouterLike): Promise<void> {
  EventTracking.trackKey('tos_and_pp.view');

  const onSubscribeSuccess = (group: { getName?: () => string }) => {
    const className = GroupDataOps.getClassName(group as any);
    if (className) {
      JoinFlowGroupStorage.setJoinedClassName(className);
    }
    ToastActions.showSuccessToast('Class joined');
    router.push(`/classes/${groupCode}?origin=subscribed`);
  };

  const onSubscribeFailure = (error: { code?: string; message?: string }) => {
    if (error.code === 'duplicate_membership') {
      ToastActions.showErrorToast(error.message || 'An error occurred.');
      router.push(`/classes/${groupCode}?origin=subscribed`);
      return;
    }

    if (error.code === 'information_required') {
      router.push(`/information_required/${groupCode}`);
      return;
    }

    ToastActions.showDefaultErrorToast();
    // Signed in already; leave /log_in so GoogleSignIn's modal cannot stick.
    router.push('/classes');
  };

  return GroupActions.subscribeToGroupWithCode(groupCode).then(
    onSubscribeSuccess,
    onSubscribeFailure
  );
}
